import { getLocale } from "../runtime";

const sv_startcheckout = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Gå till kassan`
};

const startcheckout = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_startcheckout(inputs)
	return "startCheckout";
};

export { startcheckout as "startCheckout" };